import { Tab } from '@material-ui/core';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { useAuth } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Partenaire from 'components/Icons/Partenaire';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import Partner from './components/Partner';

const PartnersSchool = () => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const [value, setValue] = useState('1');
  const intl = useIntl();
  const { checkPermissions, isPremium } = useAuth();
  const [tabOrientation, setTabOrientation] = useState('horizontal');
  const [totalElements, setTotalElements] = useState(0);

  useEffect(() => {
    const updateOrientation = () => {
      const newOrientation =
        window.innerWidth < 768 ? 'vertical' : 'horizontal';
      setTabOrientation(newOrientation);
    };

    window.addEventListener('resize', updateOrientation);
    updateOrientation();

    return () => window.removeEventListener('resize', updateOrientation);
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (isPremium !== null) {
      checkPermissions();
    }
  }, [isPremium]);

  if (!isPremium) {
    return <div></div>;
  }

  return (
    <div className={classes.container}>
      <div className={classes.paper} square>
        <TabContext value={value}>
          <TabList
            className={css({
              paddingLeft: spacing(0),
              width: '100%',
            })}
            orientation={tabOrientation}
            variant={window.innerWidth < 768 ? 'fullWidth' : 'standard'}
            indicatorColor="default"
            onChange={handleChange}
          >
            <Tab
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  borderBottom: 0,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  minWidth: '12vw',
                  borderTopRightRadius: 5,
                  background: value === '1' ? 'white' : '#F3F7FF',
                  color: value === '1' ? '#152652' : '#5A6DA1',
                  fontWeight: value === '1' ? 600 : 400,
                  '@media screen and (max-width: 768px)': {
                    width: '100%',
                  },
                }),
              }}
              className={global.mainTitle}
              label={`Nos partenaires`}
              value="1"
            />
            <Tab
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  borderBottom: 0,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  minWidth: '12vw',
                  borderTopRightRadius: 5,
                  background: value === '2' ? 'white' : '#F3F7FF',
                  color: value === '2' ? '#152652' : '#5A6DA1',
                  fontWeight: value === '2' ? 600 : 400,
                  '@media screen and (max-width: 768px)': {
                    width: '100%',
                  },
                }),
              }}
              className={global.mainTitle}
              label={`Demandes reçues`}
              value="2"
            />
            <Tab
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  borderBottom: 0,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  minWidth: '12vw',
                  borderTopRightRadius: 5,
                  background: value === '3' ? 'white' : '#F3F7FF',
                  color: value === '3' ? '#152652' : '#5A6DA1',
                  fontWeight: value === '3' ? 600 : 400,
                  '@media screen and (max-width: 768px)': {
                    width: '100%',
                  },
                }),
              }}
              className={global.mainTitle}
              label={`Demandes envoyées`}
              value="3"
            />
            <Tab
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  display: 'none',
                  borderBottom: 0,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  borderTopLeftRadius: 5,
                  opacity: 1,
                  minWidth: '12vw',
                  borderTopRightRadius: 5,
                  background: value === '4' ? 'white' : '#F3F7FF',
                  color: value === '4' ? '#152652' : '#5A6DA1',
                  fontWeight: value === '4' ? 600 : 400,
                  '@media screen and (max-width: 768px)': {
                    width: '100%',
                  },
                }),
              }}
              className={global.mainTitle}
              label={`Prospects`}
              value="4"
            />
          </TabList>
          <div>
            <TabPanel
              className={css({
                background: 'white',
                minHeight: totalElements === 0 ? 'calc(100vh - 75px - 93px)' : '100%',
                borderRadius: '0 0 10px 10px',
                padding: spacing(2.5),
                height: '100%',
              })}
              value="1"
            >
              <Partner accept={true} setTotalElements={setTotalElements} />
            </TabPanel>
            <TabPanel
              className={css({
                background: 'white',
                minHeight: totalElements === 0 ? 'calc(100vh - 75px - 93px)' : '100%',
                borderRadius: '0 0 10px 10px',
                padding: spacing(2.5),
                height: '100%',
              })}
              value="2"
            >
              <Partner from="businessToSchool" accept={false} setTotalElements={setTotalElements} />
            </TabPanel>
            <TabPanel
              className={css({
                background: 'white',
                minHeight: totalElements === 0 ? 'calc(100vh - 75px - 93px)' : '100%',
                borderRadius: '0 0 10px 10px',
                padding: spacing(2.5),
                height: '100%',
              })}
              value="3"
            >
              <Partner from="schoolToBusiness" accept={false} setTotalElements={setTotalElements} />
            </TabPanel>
            <TabPanel
              className={css({
                background: 'white',
                borderRadius: '0 0 10px 10px',
                minHeight: totalElements === 0 ? 'calc(100vh - 75px - 93px)' : '100%',
                padding: spacing(2.5),
                height: '100%',
              })}
              value="4"
            >
              <Partner from="schoolToBusiness" accept={true} setTotalElements={setTotalElements} />
            </TabPanel>
          </div>
        </TabContext>
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    padding: '50px',
    '@media only screen and (max-width:1543px)': { padding: '42px' },
    '@media only screen and (max-width:1440px)': { padding: '34px' },
    lineHeight: '110%',
    width: '100%',
    '@media only screen and (max-width:768px)': { padding: '20px' },
  },
  paper: {
    flex: '1 1 0px',
    borderRadius: 10,
  },
});

export default PartnersSchool;
